import {CustomSelect} from '../../../components/select/select.tsx';
import {useAppSelector} from '../../../store/store';
import formStyles from './../../../components/form/form.module.scss';
import {CustomerFieldKeys, getValue} from '../../../support/get_data.ts';
import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending';
import {__, transString} from '../../../support/lang/translations';
import {Country} from '../../../enums/customer_fields/Country.ts';
import {Map} from '../../../components/map/map.tsx';

export function Address() {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);

    const streetData = getValue(meData, CustomerFieldKeys.STREET);
    const houseNumberData = getValue(meData, CustomerFieldKeys.HOUSE_NUMBER);
    const houseNumberAdditionData = getValue(meData, CustomerFieldKeys.HOUSE_NUMBER_ADDITION);
    const postalCodeData = getValue(meData, CustomerFieldKeys.POSTAL_CODE);
    const cityData = getValue(meData, CustomerFieldKeys.CITY);
    const countryData = getValue(meData, CustomerFieldKeys.COUNTRY);

    const countryOptions = Object.values(Country).map((country) => {
        return {
            label: __('enums.country.' + country),
            value: country,
        };
    });
    const selectedCountryOption = countryOptions?.find((co) => co != null && co.value === countryData?.value);

    // TODO: interactive address data
    const addressData = `${streetData?.value} ${houseNumberData?.value + (houseNumberAdditionData?.value ?? '')} ${cityData?.value} ${countryData?.value}`;

    return (
        <>
            <Map addressData={addressData} />

            <div className={formStyles.form}>
                <div className={formStyles.form__grid}>
                    <div className={formStyles.grid__custom}>
                        <fieldset>
                            <legend data-grid-column-start={1} data-grid-column-end={13}>
                                {__('profile.fields.street_and_number')}
                            </legend>
                            <input
                                data-grid-column-start={1}
                                data-grid-column-end={7}
                                defaultValue={streetData?.value ?? ''}
                                placeholder={streetData?.name ?? transString('profile.fields.street')}
                                name={streetData?.key ?? CustomerFieldKeys.STREET}
                                disabled={isLoading}
                            />
                            <input
                                data-grid-column-start={7}
                                data-grid-column-end={9}
                                defaultValue={houseNumberData?.value ?? ''}
                                placeholder={transString('profile.fields.house_number')}
                                name={houseNumberData?.key ?? CustomerFieldKeys.HOUSE_NUMBER}
                                disabled={isLoading}
                            />
                            <input
                                data-grid-column-start={9}
                                data-grid-column-end={13}
                                defaultValue={houseNumberAdditionData?.value ?? ''}
                                placeholder={
                                    houseNumberAdditionData?.name ?? transString('profile.fields.house_number_addition')
                                }
                                name={houseNumberAdditionData?.key ?? CustomerFieldKeys.HOUSE_NUMBER_ADDITION}
                                disabled={isLoading}
                            />
                        </fieldset>
                        <fieldset>
                            <legend data-grid-column-start={1} data-grid-column-end={13}>
                                {__('profile.fields.street_and_number')}
                            </legend>
                            <input
                                data-grid-column-start={1}
                                data-grid-column-end={4}
                                name={postalCodeData?.key ?? CustomerFieldKeys.POSTAL_CODE}
                                placeholder={postalCodeData?.name ?? transString('profile.fields.postal_code')}
                                defaultValue={postalCodeData?.value ?? ''}
                                disabled={isLoading}
                            />
                            <input
                                data-grid-column-start={4}
                                data-grid-column-end={13}
                                defaultValue={cityData?.value ?? ''}
                                placeholder={transString('profile.fields.city')}
                                name={cityData?.key ?? CustomerFieldKeys.CITY}
                                disabled={isLoading}
                            />
                        </fieldset>
                        <div className={formStyles.grid__default}>
                            <label>
                                {countryData?.name ?? __('profile.fields.country')}
                                <br />
                                <CustomSelect
                                    name={countryData?.key ?? CustomerFieldKeys.COUNTRY}
                                    isSearchable={false}
                                    options={countryOptions}
                                    defaultValue={selectedCountryOption}
                                    isDisabled={isLoading}
                                    isLocked={false}
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
